<template>
  <div></div>
</template>

<script>
import L from "leaflet";
import "leaflet.markercluster";
import homeFast from "@/assets/img/homeFast.png";
import houseBlack from "@/assets/img/house-black.png";
import fillGreen from "@/assets/img/fill-green.png";

export default {
  props: ["map", "addresses", "fastAddresses", "zoom", "param"],
  data() {
    return {
      markerById: {},
      addressesFast: null,
      markerAddressesCluster: [],
      markerFastAddressesCluster: [],
      markerClusterGroup: null,
      idMarkerAddresses: null,
      idMarkerFast: null,
      marker: null,
      dataEntranceActive: true,
      markerEntrance: [],
      dataEntrance: [],
      activeMaps: true,
      numberEntrance: null,
      markerFast: [],
      markerAddresses: [],
      animationFrameId: null,
      clusterOptions: {
        showCoverageOnHover: true,
        maxClusterRadius: 100,
        disableClusteringAtZoom: 18,
      },
    };
  },
  watch: {
    addresses: "addressAndFast",
    fastAddresses: "addressAndFast",
  },
  mounted() {
    this.markerClusterGroup = L.markerClusterGroup(this.clusterOptions);
    this.map.addLayer(this.markerClusterGroup);
  },
  methods: {
    addressAndFast() {
      this.markerAddressesCluster = this.addresses;
      this.markerFastAddressesCluster = this.fastAddresses;
      this.handleMapEvent();
    },
    handleMapEvent() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      this.animationFrameId = requestAnimationFrame(() => {
        this.renderGeoJsonAll();
      });
    },
    renderGeoJsonAll() {
      this.markerClusterGroup.clearLayers();
      this.markerById = {};

      const iconByType = (type) =>
        L.icon({
          iconUrl: type === "fast" ? homeFast : houseBlack,
          iconSize: [15, 15],
          iconAnchor: [15, 15],
        });

      const features = [
        ...this.markerAddressesCluster.map((addr) => ({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [addr.lng, addr.lat],
          },
          properties: {
            id: addr.id,
            name: addr.number || "Без названия",
            type: "address",
            raw: addr,
          },
        })),
        ...this.markerFastAddressesCluster.map((fast) => ({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [fast.lng, fast.lat],
          },
          properties: {
            id: fast.id,
            name: fast.name || "Быстрый адрес",
            type: "fast",
            raw: fast,
          },
        })),
      ];

      features.forEach((feature) => {
        const { id, type, raw } = feature.properties;
        const latlng = L.latLng(
          feature.geometry.coordinates[1],
          feature.geometry.coordinates[0]
        );

        const marker = L.marker(latlng, {
          icon: iconByType(type),
        });

        marker.on("click", () => {
          if (
            type === "address" &&
            this.param === "address" &&
            this.dataEntranceActive
          ) {
            this.addressesID(raw);
          } else if (
            type === "fast" &&
            this.param !== "fastAdd" &&
            this.dataEntranceActive
          ) {
            this.fastID(raw);
          }

          this.$emit("markerClick", raw);
        });
        this.markerById[id] = marker;
        this.markerClusterGroup.addLayer(marker);
      });
    },
    addressesID(id) {
      if (this.addressesFast) {
        this.addMarkerById({
          id: this.addressesFast.id,
          lat: this.addressesFast.lat,
          lng: this.addressesFast.lng,
          type: this.param,
          name: this.addressesFast.name,
        });
      }
      this.addressesFast = id;
      this.removeMarkerById(id.id);
      this.idMarkerAddresses = id.id;
      this.createMarker(id);
      this.$emit("openModalAddress", id);
    },
    fastID(id) {
      if (this.addressesFast) {
        this.addMarkerById({
          id: this.addressesFast.id,
          lat: this.addressesFast.lat,
          lng: this.addressesFast.lng,
          type: this.param,
          name: this.addressesFast.name,
        });
      }
      this.addressesFast = id;
      this.removeMarkerById(id.id);
      this.idMarkerFast = id.id;
      this.createMarker(id);
      this.$emit("selectFastHouse", id);
    },
    removeMarkerById(id) {
      const marker = this.markerById[id];
      if (marker) {
        this.markerClusterGroup.removeLayer(marker);
        delete this.markerById[id];
      }
    },
    createMarkerOldAndNew(data) {
      if (data) {
        this.addMarkerById({
          ...data,
          type: this.param,
        });
      } else {
        if (this.addressesFast) {
          this.addMarkerById({
            id: this.addressesFast.id,
            lat: this.addressesFast.lat,
            lng: this.addressesFast.lng,
            type: this.param,
            name: this.addressesFast.name,
          });
          this.addressesFast = null;
        }
      }
    },
    addMarkerById(raw) {
      if (!raw || !raw.id || !raw.lat || !raw.lng) return;

      const id = raw.id;
      if (this.markerById[id] && this.markerById[id].type == this.param) return;

      const type = raw.type || (this.param === "address" ? "address" : "fast");

      const iconByType = (type) =>
        L.icon({
          iconUrl: type === "address" ? houseBlack : homeFast,
          iconSize: [15, 15],
          iconAnchor: [15, 15],
        });

      const latlng = L.latLng(raw.lat, raw.lng);

      const marker = L.marker(latlng, {
        icon: iconByType(type),
      });

      marker.on("click", () => {
        if (
          type === "address" &&
          this.param === "address" &&
          this.dataEntranceActive
        ) {
          this.addressesID(raw);
        } else if (
          type === "fast" &&
          this.param !== "fastAdd" &&
          this.dataEntranceActive
        ) {
          this.fastID(raw);
        }

        this.$emit("markerClick", raw);
      });

      this.markerById[id] = marker;
      this.markerClusterGroup.addLayer(marker);
    },
    createMarker(id) {
      if (this.marker) this.marker.remove();

      const marker = L.marker(id, {
        draggable: true,

        icon: L.icon({
          iconUrl: fillGreen,
          iconSize: [15, 15],
          iconAnchor: [15, 15],
        }),
      }).addTo(this.map);

      this.marker = marker;

      marker.on("dragend", (e) => {
        this.$emit("coordinateDragend", e.target._latlng, this.param);
      });
    },
    createEntrance(data) {
      if (data) {
        this.dataEntrance = data;
        this.fundataEntranceActive();
      }

      this.clearEntranceActive();

      const customIcon = (elem) =>
        L.divIcon({
          className: "green-icon",
          html: `<span class="icon-text">${elem.idCustom || elem.name}</span>`,
          iconSize: [10, 10],
          iconAnchor: [10, 10],
        });

      this.dataEntrance.forEach((elem) => {
        const markerEntrance = L.marker(elem, {
          draggable: true,
          icon: customIcon(elem),
        }).addTo(this.map);
        this.markerEntrance.push(markerEntrance);

        markerEntrance.on("drag", (e) => {
          this.$emit(
            "editCoordsEntrance",
            elem.idCustom || elem.id,
            e.target._latlng
          );
        });
      });
    },
    activeMap(id) {
      this.numberEntrance = id;
      this.activeMaps = false;

      const onClick = (e) => {
        if (!this.activeMaps) {
          const coords = e.latlng;
          this.dataEntrance.forEach((elem) => {
            if (elem.idCustom === this.numberEntrance) {
              elem.lat = coords.lat;
              elem.lng = coords.lng;
            }
          });
          this.createEntrance();
          this.activeMaps = true;
          this.$emit("addEntranceActiveButton");
          this.map.off("click", onClick);
        }
      };

      this.map.on("click", onClick);
    },
    fundataEntranceActive() {
      this.dataEntranceActive = !this.dataEntranceActive;
    },
    clearmarker() {
      if (this.marker) this.marker.remove();
      this.marker = null;
      this.idMarkerAddresses = null;
      this.idMarkerFast = null;
      // this.renderGeoJsonAll();
    },
    deleteAllMarker() {
      if (this.markerClusterGroup) {
        this.markerClusterGroup.clearLayers();
      }
      this.markerFast.forEach((m) => m?.remove());
      this.markerAddresses.forEach((m) => m?.remove());
      this.markerFast = [];
      this.markerAddresses = [];
    },
    clearEntranceActive() {
      this.markerEntrance.forEach((m) => m.remove());
      this.markerEntrance = [];
      this.dataEntranceActive = true;
    },
  },
};
</script>
